// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","3024": "36b953769326","3616": "2bd20f1d2224","7658": "3505e50fd8f4",}[chunkId] + ".css"
}